import { render } from "./IconBase.vue?vue&type=template&id=6e211515&scoped=true"
import script from "./IconBase.vue?vue&type=script&lang=js"
export * from "./IconBase.vue?vue&type=script&lang=js"

import "./IconBase.vue?vue&type=style&index=0&id=6e211515&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6e211515"],['__file',"src/assets/js/components/Icons/IconBase.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "6e211515"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('6e211515', __exports__)) {
    api.reload('6e211515', __exports__)
  }
  
  module.hot.accept("./IconBase.vue?vue&type=template&id=6e211515&scoped=true", () => {
    api.rerender('6e211515', render)
  })

}


export default __exports__